import { Card } from './Card';

type TrendDirection = 'up' | 'down' | 'neutral';
type StatusColor = 'success' | 'warning' | 'error' | 'info';

interface StatCardProps {
  label: string;
  value: string | number;
  subtitle?: string;
  icon?: React.ReactNode;
  trend?: TrendDirection;
  trendValue?: string;
  status?: StatusColor;
  onClick?: () => void;
}

const STATUS_BORDER: Record<StatusColor, string> = {
  success: 'border-l-success',
  warning: 'border-l-warning',
  error: 'border-l-error',
  info: 'border-l-info',
};

const TREND_STYLES: Record<TrendDirection, { arrow: string; color: string }> = {
  up: { arrow: '\u2191', color: 'text-success' },
  down: { arrow: '\u2193', color: 'text-error' },
  neutral: { arrow: '\u2192', color: 'text-text-muted' },
};

export function StatCard({
  label,
  value,
  subtitle,
  icon,
  trend,
  trendValue,
  status,
  onClick,
}: StatCardProps) {
  const borderClass = status ? `border-l-2 ${STATUS_BORDER[status]}` : '';

  return (
    <Card className={borderClass} onClick={onClick}>
      <div className="flex items-start justify-between">
        <div className="flex-1 min-w-0">
          <p className="text-xs text-text-muted uppercase tracking-wider">{label}</p>
          <p className="text-2xl font-bold text-text-primary mt-1">{value}</p>
          {subtitle ? (
            <p className="text-[10px] text-text-muted mt-0.5">{subtitle}</p>
          ) : null}
          {trend ? (
            <div className={`flex items-center gap-1 mt-1 text-xs ${TREND_STYLES[trend].color}`}>
              <span>{TREND_STYLES[trend].arrow}</span>
              {trendValue ? <span>{trendValue}</span> : null}
            </div>
          ) : null}
        </div>
        {icon ? (
          <div className="text-text-muted flex-shrink-0 ml-3 [&>svg]:h-5 [&>svg]:w-5">
            {icon}
          </div>
        ) : null}
      </div>
    </Card>
  );
}

export default StatCard;
